<template>
  <v-container fluid
               v-if="!busy">
    <page-title icon="fas fa-fw fa-envelope">
      Audit Trail for Email Template {{ templateID }}

      <template v-slot:buttons>
        <v-btn color="primary"
               :to="{name: 'admin.share_template.edit', params: {templateID: templateID}}">
          Edit
        </v-btn>
      </template>
    </page-title>

    <v-card>
      <v-simple-table>
        <thead>
        <tr>
          <th>
            ID
          </th>
          <th>
            Date
          </th>
          <th>
            User
          </th>
          <th>
            Message
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="activity in activities"
            :key="activity.id">
          <td>
            {{ activity.id }}
          </td>
          <td class="text-no-wrap">
            {{ activity.created_at | datetime }}
          </td>
          <td>
            {{ activity.causer?.name }}
          </td>
          <td>
            {{ activity.description }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-container>
</template>
<script>
import axios from '../../services/axiosService';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  data() {
    return {
      activities: [],
      busy: false,
      template: null,
    }
  },
  computed: {
    templateID() {
      return parseInt(this.$route.params.templateID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.busy = true;
      axios.get(`/api/share-templates/${this.templateID}/audit-trail`)
        .then(response => {
          this.activities = response.data;
        })
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
